// src/pages/Contact.jsx
import { motion } from "framer-motion";
import { FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900 pt-24 pb-16 px-6 lg:px-20 ">
      <div className=" max-w-7xl mx-auto">
        {/* Page Title */}
        <motion.h2
          className=" text-4xl font-bold text-center bg-gradient-to-r from-indigo-400 via-pink-400 to-purple-400 bg-clip-text text-transparent mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Contact Me
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Side - Contact Form */}
          <motion.div
            className="bg-slate-800/80 backdrop-blur-md p-8 rounded-2xl shadow-lg"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-2xl font-semibold text-white mb-6">
              Send a Message
            </h3>
            <form className="space-y-6">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full p-4 rounded-lg bg-slate-900 text-white border border-slate-700 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400 outline-none transition"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full p-4 rounded-lg bg-slate-900 text-white border border-slate-700 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400 outline-none transition"
              />
              <textarea
                rows="5"
                placeholder="Your Message"
                className="w-full p-4 rounded-lg bg-slate-900 text-white border border-slate-700 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-400 outline-none transition"
              ></textarea>
              <button
                type="submit"
                className="w-full py-4 rounded-lg font-semibold bg-gradient-to-r from-indigo-500 via-pink-500 to-purple-500 text-white hover:opacity-90 transition shadow-lg"
              >
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Right Side - Contact Info */}
          <motion.div
            className="flex flex-col justify-between space-y-8"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="bg-slate-800/80 backdrop-blur-md p-6 rounded-2xl shadow-lg flex items-center gap-6 hover:scale-105 transition">
              <FaEnvelope className="text-3xl text-red-400" />
              <div>
                <p className="text-gray-400 text-sm">Email</p>
                <a
                  href="mailto:info@topoftheworldadv.com"
                  className="text-white font-medium"
                >
                  info@topoftheworldadv.com
                </a>
              </div>
            </div>

            <div className="bg-slate-800/80 backdrop-blur-md p-6 rounded-2xl shadow-lg flex items-center gap-6 hover:scale-105 transition">
              <FaWhatsapp className="text-3xl text-green-400" />
              <div>
                <p className="text-gray-400 text-sm">WhatsApp</p>
                <a
                  href="https://wa.me/9779841492029"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white font-medium"
                >
                  +977 9841492029
                </a>
              </div>
            </div>

            <div className="bg-slate-800/80 backdrop-blur-md p-6 rounded-2xl shadow-lg flex items-center gap-6 hover:scale-105 transition">
              <FaMapMarkerAlt className="text-3xl text-indigo-400" />
              <div>
                <p className="text-gray-400 text-sm">Location</p>
                <p className="text-white font-medium">
                  Thamel & Airport Office, Kathmandu, Nepal
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Map Embed */}
        <motion.div
          className="mt-12 rounded-2xl overflow-hidden shadow-lg border border-slate-700"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
        >
          <iframe
            title="Location Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.3423285172246!2d85.31232931506674!3d27.707708832437384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19c7dcae2a4d%3A0x9fcb49e00af3f079!2sThamel%2C%20Kathmandu!5e0!3m2!1sen!2snp!4v1633423442345!5m2!1sen!2snp"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </motion.div>
      </div>
    </div>
  );
}
